import moment from 'moment/moment';
import pluralize from 'pluralize';
import { getOrgTermsContent } from '../../../../../content/utils.js';

export const createTooltipsReportProject = (data) => {
  const createImpactHtml = (impact) => `
  <div class="m-t-28 text-left">
    <h4 class="m-b-14 flex flex-align-center">
      <span class="m-l-8 cursor-pointer" style="margin-top: 2px;">${impact.title}</span>
    </h4>
    <div class="m-b-12 m-l-32">
      <span class="text-muted" style="display:inline-block; min-width:115px">Dates: </span>
      <span class="">
        ${moment(impact.startDate).format('MM/DD/YY')} - ${moment(impact.endDate).format('MM/DD/YY')}
      </span>
    </div>
    <div class="m-b-12 m-l-32">
      <span class="text-muted" style="display:inline-block; min-width:115px">Scale: </span>
      <span class="sentiment-dot sentiment-dot-sm sentiment-dot-${impact.scale?.toLowerCase()}-reverse"></span>
      <span class="text-capitalize">${impact.scale ?? '—'}</span>
    </div>
    <div class="m-b-12 m-l-32">
      <span class="text-muted" style="display:inline-block; min-width:115px">Perception: </span>
      <span class="sentiment-dot sentiment-dot-sm sentiment-dot-${impact.perception?.toLowerCase()}"></span>
      <span class="text-capitalize">${impact.perception ?? '—'}</span>
    </div>
  </div>`;

  let contentImpacts = '';
  if (data?.impacts) {
    contentImpacts = data.impacts.slice(0, 4).map(createImpactHtml).join('');
  }

  const contentTooltip = `
  <div class="text-left m-b-30 flex">
    <h4 class="strong m-r-8">Date:  
      <span class="text-normal" style="font-size: 16px;">${data?.date ? moment(data.date).format('MM/DD/YYYY') : ''}</span>
    </h4>
    <strong class="m-l-8 bordered text-muted">
      Total:&nbsp;<span class="text-primary count">${data?.impacts ? data.impacts.length : 0}</span>
    </strong>
  </div>
  <div>${contentImpacts}</div>
  <div class="text-primary count text-left">
    ${data?.impacts?.length > 4 ? `+${data.impacts.length - 4} more` : ''}
  </div>`;

  const contentEmptyTooltip = `
  <div class="text-left m-b-30 flex">
    <h4 class="strong m-r-8">Date:  
      <span class="text-normal" style="font-size: 16px;">${data?.date ? moment(data.date).format('MM/DD/YYYY') : ''}</span>
    </h4>
    <strong class="m-l-8 bordered text-muted">
      Total:&nbsp;<span class="text-primary count">${data?.impacts ? data.impacts.length : 0}</span>
    </strong>
  </div>
  <div class="text-left text-muted">
    There are no Change Impacts for this date
  </div>`;

  return {
    contentTooltip,
    contentEmptyTooltip,
  };
};

function calculateProjectImpacts(data) {
  const uniqueProjects = {};
  let shownImpacts = 0;

  data.impacts.forEach((impact) => {
    if (!uniqueProjects[impact.projectId]) {
      uniqueProjects[impact.projectId] = {
        projectName: impact.projectName,
        impacts: [],
      };
    }

    uniqueProjects[impact.projectId].impacts.push(impact);
  });

  const projectsArray = Object.keys(uniqueProjects).map((projectId) => {
    const project = uniqueProjects[projectId];
    const impactsToShow = project.impacts.slice(0, 3 - shownImpacts);

    shownImpacts += impactsToShow.length;

    return {
      projectId: parseInt(projectId, 10),
      projectName: project.projectName,
      impactCount: project.impacts.length,
      impacts: impactsToShow,
    };
  });

  return projectsArray;
}

export const createTooltipsReportEnterprise = (data) => {
  const sortedProjects = calculateProjectImpacts(data);

  const createImpactHtml = (impact) => `
  <div class="m-t-28 text-left">
    <h4 class="m-b-14 flex flex-align-center">
      <span class="m-l-8 cursor-pointer" style="margin-top: 2px;">${impact.title}</span>
    </h4>
    <div class="m-b-12 m-l-32">
      <span class="text-muted" style="display:inline-block; min-width:115px">Dates: </span>
      <span class="">
        ${moment(impact.startDate).format('MM/DD/YY')} - ${moment(impact.endDate).format('MM/DD/YY')}
      </span>
    </div>
    <div class="m-b-12 m-l-32">
      <span class="text-muted" style="display:inline-block; min-width:115px">Scale: </span>
      <span class="sentiment-dot sentiment-dot-sm sentiment-dot-${impact.scale?.toLowerCase()}-reverse"></span>
      <span class="text-capitalize">${impact.scale}</span>
    </div>
    <div class="m-b-12 m-l-32" style="padding-bottom: 12px">
      <span class="text-muted" style="display:inline-block; min-width:115px">Perception: </span>
      <span class="sentiment-dot sentiment-dot-sm sentiment-dot-${impact.perception?.toLowerCase()}"></span>
      <span class="text-capitalize">${impact.perception}</span>
    </div>
  </div>`;

  const contentImpacts = {};

  if (data?.impacts) {
    sortedProjects.forEach((project) => {
      contentImpacts[project.projectId] = project.impacts
        .map(createImpactHtml)
        .join('');
    });
  }

  const createProjectHtml = (project, index) => `
  <div class="text-left ${index !== 0 ? 'component-border-top' : ''}" style="padding-top: 22px">
    <div class="flex m-b-14">
    <h4 class="flex flex-align-center">
      <span class="m-l-8 cursor-pointer" style="margin-top: 2px;">${project.projectName}</span>
     </h4>   
     <strong class="bordered text-muted m-l-8" style="height: 28px; font-size: 14px;">
      Total:&nbsp;<span class="text-primary count">${project.impactCount}</span>
    </strong>
    </div>
    <div class="m-l-32">
    ${contentImpacts[project.projectId]}
    </div>
  </div>`;

  const contentProject = sortedProjects
    .filter((p) => p.impacts.length > 0)
    .map(createProjectHtml)
    .join('');

  const contentTooltip = `
  <div class="text-left">
    <h4 class="strong m-r-8 m-b-16">Date:  
      <span class="text-normal" style="font-size: 16px;">${data?.date ? moment(data.date).format('MM/DD/YYYY') : ''}</span>
    </h4>
    <div>
    <strong class="bordered text-muted" style="height: 28px">
      ${pluralize(getOrgTermsContent('project'), sortedProjects.length)}:&nbsp;<span class="text-primary count">${sortedProjects.length}</span>
    </strong>
    <strong class="m-l-8 bordered text-muted" style="height: 28px">
      Change ${pluralize('Impact', data?.impacts?.length)}:&nbsp;<span class="text-primary count">${data?.impacts?.length}</span>
    </strong>
  </div>
  </div>
  <div>${contentProject}</div>
  <div class="text-primary count text-left">
    ${data?.impacts?.length > 3 ? `+${data.impacts.length - 3} more` : ''}
  </div>`;

  const contentEmptyTooltip = `
  <div class="text-left m-b-30 flex">
    <h4 class="strong m-r-8">Date:  
      <span class="text-normal" style="font-size: 16px;">${data?.date ? moment(data.date).format('MM/DD/YYYY') : ''}</span>
    </h4>
    <strong class="bordered text-muted m-l-8" style="height: 28px; font-size: 14px;">
      Total:&nbsp;<span class="text-primary count">${data?.impacts ? data.impacts.length : 0}</span>
    </strong>
  </div>
  <div class="text-left text-muted">
    There are no Change Impacts for this date
  </div>`;

  return {
    contentTooltipEnterprise: contentTooltip,
    contentEmptyTooltipEnterprise: contentEmptyTooltip,
  };
};
